import { render, staticRenderFns } from "./NewScheduling.vue?vue&type=template&id=552ce521&scoped=true"
import script from "./NewScheduling.vue?vue&type=script&lang=js"
export * from "./NewScheduling.vue?vue&type=script&lang=js"
import style0 from "./NewScheduling.vue?vue&type=style&index=0&id=552ce521&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ce521",
  null
  
)

export default component.exports